var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99781 16.3332C8.38697 16.3332 6.92867 15.6803 5.87305 14.6247L9.99781 10.4998V4.6665C13.2195 4.6665 15.8311 7.27818 15.8311 10.4998C15.8311 13.7215 13.2195 16.3332 9.99781 16.3332Z",
    fill: "#898E99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1654 10.4997C19.1654 15.5623 15.0613 19.6663 9.9987 19.6663C4.93609 19.6663 0.832031 15.5623 0.832031 10.4997C0.832031 5.43707 4.93609 1.33301 9.9987 1.33301C15.0613 1.33301 19.1654 5.43707 19.1654 10.4997ZM17.4987 10.4997C17.4987 14.6418 14.1409 17.9997 9.9987 17.9997C5.85656 17.9997 2.4987 14.6418 2.4987 10.4997C2.4987 6.35754 5.85656 2.99967 9.9987 2.99967C14.1409 2.99967 17.4987 6.35754 17.4987 10.4997Z",
    fill: "#898E99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSending);
export default __webpack_public_path__ + "static/media/Sending.0804ab03b14b6df5bea5d45cb78a8c3b.svg";
export { ForwardRef as ReactComponent };